import * as Yup from 'yup';
import emojiRegex from 'emoji-regex';
import isEmailValidator from 'validator/lib/isEmail';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { getAge, validatePostCode } from '../../helpers/helpers';

const allSameChars = /^(.)\1*$/;
const allSymbols = /^[-!$%^&*()_+|~=`{}[\]:";'<>?,./]*$/;
const allNumbers = /^[0-9]*$/;
const allSpaces = /^[\s]*$/;
const allowedChars = /^[a-zA-ZÀ-ÖØ-öø-ÿ\-—./']*$/;
const nameSpecificValidations = Yup.string()
  .required('validation.fieldRequired')
  .min(3, 'validation.moreThan3Chars')
  .max(50, 'validation.lessThan50Chars')
  .test('is-valid', 'validation.hasInvalidChars', (value) => allowedChars.test(value))
  .test('no-emojis', 'validation.noEmojis', (value) => !emojiRegex().test(value))
  .test('not-all-same-chars', 'validation.notAllSameChars', (value) => !allSameChars.test(value))
  .test('not-all-symbols', 'validation.notAllSymbols', (value) => !allSymbols.test(value))
  .test('not-all-numbers', 'validation.notAllNumbers', (value) => !allNumbers.test(value))
  .test('not-all-spaces', 'validation.notAllSpaces', (value) => !allSpaces.test(value));

const validationSchema = (includeEmailField: boolean) =>
  Yup.object({
    title: Yup.string().required('validation.fieldRequired'),
    firstName: nameSpecificValidations,
    lastName: nameSpecificValidations,
    role: Yup.string().required('validation.fieldRequired'),
    emailAddress: includeEmailField
      ? Yup.string()
          .max(50, 'validation.lessThan50Chars')
          .test('is-valid', 'validation.validEmail', (value) =>
            value ? isEmailValidator(value) : false
          )
      : undefined,
    dateOfBirth: Yup.string()
      .required('validation.fieldRequired')
      .test('is-valid', 'validation.mustBe14OrOlder', (value) => getAge(new Date(value)) >= 14), // User must be 14 or older
    phoneNumber: Yup.string()
      .required('validation.fieldRequired')
      .test(
        'is-valid',
        'validation.invalidPhoneNumber',
        (value) => value && isValidPhoneNumber(value)
      ),
    addressLine1: Yup.string()
      .required('validation.fieldRequired')
      .max(100, 'validation.lessThan100Chars'),
    addressLine2: Yup.string().max(50, 'validation.lessThan50Chars'),
    town: Yup.string().required('validation.fieldRequired').max(50, 'validation.lessThan50Chars'),
    county: Yup.string().max(50, 'validation.lessThan50Chars'),
    country: Yup.string()
      .required('validation.fieldRequired')
      .max(50, 'validation.lessThan50Chars'),
    postCode: Yup.string()
      .required('validation.fieldRequired')
      .test('postCode', 'validation.invalidPostCode', function (value) {
        const { country } = this.parent;
        return validatePostCode(value, country);
      }),
  });

export default validationSchema;
